import router from './router'
import breachOfTrustMessages from './localization'

export default {
  router,
  localization: breachOfTrustMessages,
}
